import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/onlineStudy/index2.png';
import _imports_1 from '../../assets/img/onlineStudy/index5.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6c2eb6b6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "window"
};
var _hoisted_2 = {
  class: "flex"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "返回", -1);
});

var _hoisted_4 = {
  class: "content_box"
};
var _hoisted_5 = {
  class: "list_box flex flex_justify_center"
};
var _hoisted_6 = {
  key: 0,
  class: "prompt"
};
var _hoisted_7 = {
  key: 1,
  class: "prompt"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 加载中... ");

var _hoisted_9 = {
  key: 2,
  class: "items"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "container describe"
};
var _hoisted_12 = {
  key: 0,
  class: "left"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  key: 0,
  class: "suspended"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_16 = {
  class: "middle"
};
var _hoisted_17 = {
  class: "pagone"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "pagone"
  }, " 学分:2 ", -1);
});

var _hoisted_19 = {
  key: 0,
  class: "pagone"
};
var _hoisted_20 = {
  class: "pagone",
  style: {
    "width": "230px"
  }
};

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "学习进度", -1);
});

var _hoisted_22 = {
  style: {
    "display": "inline-block",
    "width": "150px",
    "margin-left": "10px"
  }
};
var _hoisted_23 = {
  class: "right"
};
var _hoisted_24 = ["onClick"];

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1);
});

var _hoisted_26 = /*#__PURE__*/_createTextVNode(" 取消收藏 ");

var _hoisted_27 = [_hoisted_25, _hoisted_26];
var _hoisted_28 = {
  class: "footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_Head = _resolveComponent("Head");

  var _component_Loading = _resolveComponent("Loading");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Head, {
    title: "在线学习",
    back: false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "back",
        onClick: _cache[0] || (_cache[0] = //@ts-ignore
        function () {
          return _ctx.back && _ctx.back.apply(_ctx, arguments);
        })
      }, [_hoisted_3, _createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_ArrowRight, {
            color: "#c62423"
          })];
        }),
        _: 1
      })])];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_ctx.loading && _ctx.listData.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 暂无数据 ～ ")) : _createCommentVNode("", true), !_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_icon, {
    class: "is-loading"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_Loading)];
    }),
    _: 1
  }), _hoisted_8])) : _createCommentVNode("", true), _ctx.listData.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "list_item",
      onClick: function onClick($event) {
        return _ctx.toPage(item.contentId);
      }
    }, [_createElementVNode("div", _hoisted_11, [item.imgUrl || item.targetPath ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
      src: item.imgUrl ? _ctx.baseUrl + item.imgUrl : _ctx.baseUrl + item.source,
      alt: ""
    }, null, 8, _hoisted_13), item.targetPath && !item.imgUrl ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createTextVNode(" " + _toDisplayString(_ctx.secTotime(item.studyDuration)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, _toDisplayString(item.title), 1), _createElementVNode("div", {
      class: "middleBom",
      style: _normalizeStyle({
        marginTop: item.imgUrl || item.source ? '72px' : '42px'
      })
    }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.createTime), 1), _hoisted_18, item.studyTime ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 学时:" + _toDisplayString(item.studyTime ? _ctx.conversion(item.studyTime, item.studyDuration) : 0), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_progress, {
      percentage: _ctx.percent(item)
    }, null, 8, ["percentage"])])])], 4)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
      class: "collect",
      style: _normalizeStyle({
        marginTop: item.imgUrl || item.source ? '80px' : '50px'
      }),
      onClick: _withModifiers(function ($event) {
        return _ctx.handleCollect(item.collectionId);
      }, ["stop"])
    }, _hoisted_27, 12, _hoisted_24)])])], 8, _hoisted_10);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_ctx.totalNum > 0 ? (_openBlock(), _createBlock(_component_Pagination, {
    key: 0,
    pagesize: 10,
    "total-num": _ctx.totalNum,
    onChangPage: _ctx.changPage
  }, null, 8, ["total-num", "onChangPage"])) : _createCommentVNode("", true)])])])]);
}